// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import { sync } from 'vuex-router-sync'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import topnav from './components/topnav.vue'
Vue.component('topnav',topnav)
import nomore from './components/nomore.vue'
Vue.component('nomore',nomore)
import callView from './components/call-view.vue'
Vue.component('callview',callView)

import Clipboard from 'v-clipboard'
Vue.use(Clipboard)

// 引用axios
import api from './api/api.js'
Vue.prototype.$api = api
Vue.use(ElementUI)
sync(store, router)
var whiteList = ['/login','/','/information','/technics','/risk','/train','/finance','/tenancy','/company','/policydetail','/techdetail','/risklist','/traindetail','/riskdetail','/financedetail','/comdetail','/tenancydetail']
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('token')
  // console.log(to.path)
  // console.log(whiteList)
  if(whiteList.indexOf(to.path) != -1){
    // console.log("白名单")
    next()
    return
  }
  if(!token){
    // websocketRequest.closeWebSocket();
    next('/login');
    return
  }
  //配置动态路由信息
  let newRouter = null;

  // if(store.getters.newRouter === newRouter)
    next()
  // else{
  //     router.addRoutes(newRouter) //添加动态路由
  //     store.dispatch('routerAction',newRouter).then(res => {
  //       next({ ...to })
  //     }).catch(() => {
  //     })
  // }
})
Vue.filter('addurl', function(value) {
	let url = value;
	if (url) {
		if (value.indexOf("http") == -1) {
			url = 'https://yt.daoben.net/' + value
		}
	}
	return url
})
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js